export function normalizeVentasIreneRows(data, year) {
  return (data || []).map((row) => ({
    ...row,
    E_MAIL: row.E_MAIL ?? row.e_mail ?? row.email ?? null,
    REPALIAS:
      row.REPALIAS ??
      row.repalias ??
      row.AccountManager ??
      row.accountManager ??
      null,
    CLIPRO:
      row.CLIPRO ??
      row.clipro ??
      row.Customer ??
      row.customer ??
      null,
    MONTH: Number(row.MONTH ?? row.month ?? 0),
    YEAR: Number(row.YEAR ?? row.year ?? year),
    TIPOCONT: Number(row.TIPOCONT ?? row.tipocont ?? 1),
    Sales: Number(
      row.Sales ?? row.sales ?? row.VentaBaseEUR ?? row.ventaBaseEUR ?? 0,
    ),
  }));
}

export function filterVentasIreneByUser(rows, userEmail, isAdmin) {
  if (isAdmin) return rows;
  return rows.filter(
    (row) =>
      row.E_MAIL?.toLowerCase().trim() === userEmail.toLowerCase().trim(),
  );
}

export function getValidVentasRows(rows) {
  return rows.filter((row) => row.REPALIAS && row.CLIPRO);
}
